<div class="flex-column flex-fill">
  <div class="row pb-2">
    <div class="col-md-12">
      @if (showWarning) {
        <div class="alert alert-danger">Wells can not be assigned to multiple Initial Build or Expansion Projects.</div>
      }
      <div class="float-end custom-split-button">
        <kendo-splitbutton #removeButton [data]="removeButtonData" themeColor="primary" [disabled]="selectedWells.length === 0 || loading" (buttonClick)="removeButton.togglePopupVisibility()">
          Remove From Project
        </kendo-splitbutton>
        <kendo-splitbutton #createButton [data]="createButtonData" themeColor="primary" [disabled]="selectedWells.length === 0 || loading" (buttonClick)="createButton.togglePopupVisibility()">
          Create Project
        </kendo-splitbutton>
        @if (loading) {
          <kendo-loader type="converging-spinner" size="small"></kendo-loader>
        }
      </div>
    </div>
  </div>
  <ag-grid-angular #agGridFF
    style="height:100%;min-height:500px;"
    class="ag-theme-balham"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (rowDataChanged)="onRowDataChanged($event)"
    (rowSelected)="onSelectedRowAdded($event)">
  </ag-grid-angular>
</div>